export default "__VITE_ASSET__BJTIQXxx__"